
import Vue from 'vue'

export default ({id, fullDocumentation, physicalDocumentation}) =>
  Vue.$http.post(`sinisters/affected/${id}/administrative_check/`, {
    full_documentation: !!fullDocumentation,
    physical_documentation: !!physicalDocumentation
  }).then(response => response.data)
    .catch((error) => {throw error})





// WEBPACK FOOTER //
// ./src/services/sinister/checkFullDocumentation.js